<template>
  <section id="recent" class="tab-pane">
    <template v-if="newestsData.length == 0">
      <LoadingCard v-for="item in 5" :key="item" />
    </template>
    <template v-else>
      <article
        v-for="(item, key) in newestsData"
        :key="key"
        class="pt-3 px-3 pt-sm-3 px-sm-5"
        type="Suggestion"
        objectid="b2877315-78da-eb11-bacb-000d3addce7f"
      >
        <div class="d-flex flex-nowrap">
          <img
            v-if="item.UserProfileImage"
            class="article-user-img fallback-image"
            :src="`data:image/png;base64, ${item.UserProfileImage}`"
            :alt="item.CreatedCustomerName | getInitialsFilter"
          />
          <i
            v-else
            class="article-user-img fallback-image flex-shrink-0"
            :alt="item.CreatedCustomerName | getInitialsFilter"
            >{{ item.CreatedCustomerName | getInitialsFilter }}</i
          >
          <div
            class="article-user-info flex-grow-1 pl-2 pl-sm-3 pt-sm-2 align-self-center align-self-sm-auto"
          >
            <span class="mb-1"
              >{{ item.CreatedCustomerName }} ( {{ item.CompanyName }} )</span
            >
            <span class="pt-0"
              >{{ item.CreatedCustomerCompanyName }} şirketinden paylaşılan
              fikir</span
            >
          </div>
          <div
            class="article-further-menu dropdown ml-1 ml-sm-2 ml-md-3 ml-lg-4 show"
            v-if="
              user.Data.UserId === item.CreatedCustomerId &&
              item.SuggestionStatusId == '1'
            "
          >
            <a
              class="btn btn-outline-light"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              @click.stop="cardDropdownFn(item.Id)"
            >
              <svg width="15px" height="3px">
                <path
                  fill-rule="evenodd"
                  opacity="0.902"
                  fill="rgb(53, 59, 72)"
                  d="M13.333,3.000 C12.413,3.000 11.666,2.328 11.666,1.500 C11.666,0.672 12.413,-0.000 13.333,-0.000 C14.254,-0.000 15.000,0.672 15.000,1.500 C15.000,2.328 14.254,3.000 13.333,3.000 ZM7.500,3.000 C6.579,3.000 5.833,2.328 5.833,1.500 C5.833,0.672 6.579,-0.000 7.500,-0.000 C8.420,-0.000 9.166,0.672 9.166,1.500 C9.166,2.328 8.420,3.000 7.500,3.000 ZM1.666,3.000 C0.746,3.000 -0.000,2.328 -0.000,1.500 C-0.000,0.672 0.746,-0.000 1.666,-0.000 C2.587,-0.000 3.333,0.672 3.333,1.500 C3.333,2.328 2.587,3.000 1.666,3.000 Z"
                ></path>
              </svg>
            </a>
            <div
              v-if="item.Id === cardDropdownId"
              ref="carDropdown"
              class="dropdown-menu dropdown-menu-right show"
              x-placement="bottom-end"
              style="
                position: absolute;
                transform: translate3d(-121px, 36px, 0px);
                top: 0px;
                left: 0px;
                will-change: transform;
                cursor: pointer;
              "
            >
              <a class="dropdown-item" @click="deleteCardShowModal(item.Id)"
                >Sil</a
              >
              <a class="dropdown-item" @click.stop="editSuggestion(item)"
                >Düzenle</a
              >
            </div>
          </div>
        </div>

        <div class="article-img clearfix"></div>
        <h2
          class="article-header"
          data-toggle="modal"
          data-target="#modal-idea-detail"
        >
          <svg width="37px" height="30px">
            <path
              fill-rule="evenodd"
              d="M12.476,21.730 C14.795,18.628 15.955,15.122 15.955,11.209 C15.955,7.847 15.103,5.166 13.398,3.166 C11.694,1.166 9.668,0.166 7.321,0.166 C5.309,0.166 3.598,0.906 2.187,2.384 C0.777,3.862 0.071,5.572 0.071,7.514 C0.071,9.368 0.686,10.970 1.915,12.318 C3.145,13.665 4.555,14.339 6.148,14.339 C7.517,14.339 8.648,14.005 9.542,13.339 C9.822,13.136 10.032,13.035 10.171,13.035 C10.311,13.035 10.437,13.122 10.548,13.296 C10.716,13.556 10.800,13.962 10.800,14.513 C10.800,17.063 9.976,19.519 8.327,21.882 C6.679,24.243 4.402,25.975 1.496,27.077 L1.496,29.207 C6.497,27.323 10.157,24.830 12.476,21.730 ZM32.635,21.730 C34.954,18.628 36.113,15.122 36.113,11.209 C36.113,7.847 35.261,5.166 33.557,3.166 C31.853,1.166 29.827,0.166 27.480,0.166 C25.468,0.166 23.757,0.906 22.346,2.384 C20.935,3.862 20.229,5.572 20.229,7.514 C20.229,9.368 20.844,10.970 22.073,12.318 C23.303,13.665 24.714,14.339 26.306,14.339 C27.676,14.339 28.807,14.005 29.701,13.339 C29.981,13.136 30.190,13.035 30.330,13.035 C30.470,13.035 30.595,13.122 30.707,13.296 C30.874,13.556 30.958,13.962 30.958,14.513 C30.958,17.063 30.134,19.519 28.486,21.882 C26.837,24.243 24.560,25.975 21.654,27.077 L21.654,29.207 C26.656,27.323 30.316,24.830 32.635,21.730 Z"
            ></path>
          </svg>
          <span @click.stop="cardDetail(item)">{{ item.Problem }}</span>
        </h2>

        <p class="article-content">{{ item.SuggestionDetail }}</p>

        <div
          class="article-response d-flex justify-content-end align-items-center flex-wrap"
        >
          <span
            class="wholiked__wrapper"
            :style="[item.LikeCount > 0 ? { cursor: 'pointer' } : '']"
            @click.stop="whoLikedFn(item.Id)"
            >{{ item.LikeCount }} kişi beğendi
            <transition name="fade">
              <ul
                v-if="whoLikedId == item.Id && item.LikeCount > 0"
                class="wholiked__wrapper--list"
                ref="whoLikedList"
              >
                <li
                  class="wholiked__wrapper--list-item"
                  v-for="like in item.Likes"
                  :key="like.Id"
                >
                  <img
                    v-if="like.UserProfileImage"
                    style="width: 24px; height: 24px"
                    class="article-user-img fallback-image"
                    :src="`data:image/png;base64, ${like.UserProfileImage}`"
                    :alt="like.UserName | getInitialsFilter"
                  />
                  <i
                    v-else
                    class="article-user-img fallback-image flex-shrink-0"
                    style="
                      height: 24px;
                      width: 24px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 10px;
                    "
                    :alt="like.UserName | getInitialsFilter"
                    >{{ like.UserName | getInitialsFilter }}</i
                  >
                  <span style="margin-left: 10px">{{ like.UserName }}</span>
                </li>
              </ul>
            </transition></span
          >
          <span>{{ item.CommentCount }} yorum</span>
          <span
            class="statu-circle"
            :class="[
              {
                'statu-green':
                  item.SuggestionStatusId == '6' ||
                  item.SuggestionStatusId == '8',
              },
              {
                'statu-red':
                  item.SuggestionStatusId == '4' ||
                  item.SuggestionStatusId == '7' ||
                  item.SuggestionStatusId == '10',
              },
              {
                'statu-blue':
                  item.SuggestionStatusId == '1' ||
                  item.SuggestionStatusId == '2' ||
                  item.SuggestionStatusId == '3' ||
                  item.SuggestionStatusId == '5' ||
                  item.SuggestionStatusId == '9',
              },
            ]"
            >{{ item.SuggestionStatusName }}</span
          >
        </div>

        <div class="article-actions py-1">
          <span class="icon-clock" :title="item.SuggestionDate" tooltip="">{{
            dateDiff(item.SuggestionDate)
          }}</span>
          <button
            @click="isCommentFn(key)"
            :aria-pressed="[key !== commentId ? false : true]"
            class="btn-article-action make-comment icon-bubbles btn-toggle"
          >
            <span class="d-none d-sm-inline">Yorum Yap</span>
          </button>
          <input
            :id="item.Id"
            type="checkbox"
            class="give-heart"
            :checked="item.IsLiked"
          />
          <label
            :for="item.Id"
            class="btn-article-action btn-article-action-label"
            @click="liked(item)"
            ><i class="fas fa-heart"></i><i class="far fa-heart"></i
            ><span class="d-none d-sm-inline">Beğen</span></label
          >
          <button
            @click.stop="supportShowModal(item.Id)"
            class="btn-article-action icon-arrow-right"
            data-toggle="modal"
            data-target="#modal-support"
          >
            <span
              class="d-none d-sm-inline tooltipper"
              title="Destek iste tooltip"
              >Destek İste</span
            >
          </button>
          <button
            style="display: none"
            class="btn-article-action icon-rocket"
            title="Sponsor Ol"
            data-toggle="modal"
            data-target="#modal-sponsor"
            onclick="OpenSponsorModal('b2877315-78da-eb11-bacb-000d3addce7f')"
          >
            <span
              class="d-none d-sm-inline tooltipper"
              title="Sponsor Ol tooltip"
              >Sponsor Ol</span
            >
          </button>
        </div>
        <transition name="slide-down">
          <div v-if="key === commentId" class="article-reply">
            <img
              v-if="user.Data.UserProfileImage"
              class="comment-user-img fallback-image"
              :src="`data:image/png;base64, ${user.Data.UserProfileImage}`"
              :alt="user.Data.FullName | getInitialsFilter"
            />
            <i
              v-else
              class="comment-user-img fallback-image"
              :alt="user.Data.FullName | getInitialsFilter"
              >{{ user.Data.FullName | getInitialsFilter }}</i
            >
            <div class="icon-note">
              <textarea
                v-model="commentText"
                class="autofit"
                placeholder="Yorum Giriniz..."
              ></textarea>
            </div>
            <div
              v-if="commentText && commentText.length > 0"
              class="text-right pt-3"
            >
              <button class="btn-reply btn-cancel" @click="commentText = ''">
                VAZGEÇ
              </button>
              <button
                class="btn-reply add-comment-button"
                @click="createComment(item)"
              >
                YANITLA
              </button>
            </div>
          </div>
        </transition>
        <a
          v-if="item.CommentCount != 0"
          class="article-comment-show icon-down"
          @click="commentShowFn(item.Id)"
          >{{ item.CommentCount }} Yorum</a
        >
        <transition name="slide-down">
          <div
            v-if="isCommentShowId == item.Id"
            class="article-comment-container"
            style=""
          >
            <div
              id="commentdiv"
              v-for="comment in item.Comments"
              :key="comment.Id"
            >
              <div
                v-show="comment.UserId == user.Data.UserId"
                class="article-further-menu dropdown show"
                style="right: 10px; margin-top: 10px; position: absolute"
              >
                <a
                  class="btn btn-outline-light"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  @click.stop="commentEditFn(comment.Id)"
                >
                  <svg width="15px" height="3px">
                    <path
                      fill-rule="evenodd"
                      opacity="0.902"
                      fill="rgb(53, 59, 72)"
                      d="M13.333,3.000 C12.413,3.000 11.666,2.328 11.666,1.500 C11.666,0.672 12.413,-0.000 13.333,-0.000 C14.254,-0.000 15.000,0.672 15.000,1.500 C15.000,2.328 14.254,3.000 13.333,3.000 ZM7.500,3.000 C6.579,3.000 5.833,2.328 5.833,1.500 C5.833,0.672 6.579,-0.000 7.500,-0.000 C8.420,-0.000 9.166,0.672 9.166,1.500 C9.166,2.328 8.420,3.000 7.500,3.000 ZM1.666,3.000 C0.746,3.000 -0.000,2.328 -0.000,1.500 C-0.000,0.672 0.746,-0.000 1.666,-0.000 C2.587,-0.000 3.333,0.672 3.333,1.500 C3.333,2.328 2.587,3.000 1.666,3.000 Z"
                    ></path>
                  </svg>
                </a>
                <div
                  ref="commentEditPoppup"
                  class="dropdown-menu dropdown-menu-right"
                  :style="[
                    commnetEditId == comment.Id
                      ? { display: 'block', cursor: 'pointer' }
                      : '',
                  ]"
                >
                  <a class="dropdown-item" @click="deleteComment(comment)"
                    >Sil</a
                  >
                  <a
                    class="dropdown-item"
                    @click.stop="commentEditShowModal(comment)"
                    >Düzenle</a
                  >
                </div>
              </div>
              <div
                class="article-comment"
                id="article-comment-id"
                style="position: static"
              >
                <div class="article-comment-body">
                  <img
                    v-if="comment.UserProfileImage"
                    class="comment-user-img fallback-image"
                    :src="`data:image/png;base64, ${comment.UserProfileImage}`"
                    :alt="comment.UserName | getInitialsFilter"
                  />
                  <i
                    v-else
                    class="comment-user-img fallback-image"
                    :alt="comment.UserName | getInitialsFilter"
                    >{{ comment.UserName | getInitialsFilter }}</i
                  >
                  <span
                    >{{ comment.UserName }} ({{
                      comment.UserCompanyName
                    }})</span
                  ><span class="icon-clock" :title="comment.CreatedOnUtc">
                    {{ dateDiff(comment.CreatedOnUtc) }}</span
                  >
                  <p
                    style="
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    "
                  >
                    {{ comment.CommentText }}
                  </p>
                </div>
                <div
                  class="article-comment-container"
                  style="display: none"
                ></div>
              </div>
            </div>
          </div>
        </transition>
      </article>
    </template>
    <div
      ref="scrollSentinel"
      class="load-more mt-5 mb-0"
      v-if="newestsData.length < totalRecords"
    >
      <span>Yükleniyor...</span>
    </div>
    <transition name="fade">
      <!-- <CardDetail
        v-if="isDetail"
        @close="isDetail = $event"
        :detailData="detailData"
        isSuggestion="newests-card"
      /> -->
      <IdeaModal
        :detailData="detailData"
        v-if="isDetail"
        @close="isDetail = $event"
      />
    </transition>
    <transition name="fade">
      <SuggestionSupport
        v-if="isSuggestionSupport"
        @close="isSuggestionSupport = $event"
        :suggestionId="suggestionId"
      />
    </transition>
    <transition name="fade">
      <CommentEdit
        v-if="isCommentEdit"
        @close="isCommentEdit = $event"
        @edit-comment="editComment"
        :commentEditData="commentEditData"
      />
    </transition>
    <transition name="fade">
      <CardDelete
        v-if="isCardDelete"
        @close="isCardDelete = $event"
        @delete="deleteCard"
        :isSuggestion="false"
      />
    </transition>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
  suggestionStatus,
  getInitials,
  fileTypeCheck,
  lowerCaseKeys,
  currentDateTime,
} from "../../../helpers";
import { suggestionService, upload } from "../../../services";
// import CardDetail from "./Modals/CardDetail.vue";
import SuggestionSupport from "./Modals/SuggestionSupport.vue";
import CommentEdit from "./Modals/CommentEdit.vue";
import CardDelete from "./Modals/CardDelete.vue";
import LoadingCard from "./LoadingCard.vue";
import IdeaModal from "../../../components/MyIdea/Modals/IdeaModal.vue";

export default {
  name: "NewestsCard",
  data() {
    return {
      isDetail: false,
      isSuggestionSupport: false,
      detailData: null,
      commentId: null,
      pageIndex: 0,
      tmpLikeId: null,
      isCommentShowId: null,
      commentText: "",
      commnetEditId: null,
      isCommentEdit: false,
      commentEditData: null,
      whoLikedId: null,
      cardDropdownId: null,
      isCardDelete: false,
      cardDeleteDataId: null,
      suggestionId: null,
      observer: null,
    };
  },
  components: {
    // CardDetail,
    SuggestionSupport,
    CommentEdit,
    CardDelete,
    LoadingCard,
    IdeaModal,
  },
  filters: {
    suggestionStatusFilter(value) {
      return suggestionStatus(value);
    },
    getInitialsFilter(value) {
      return getInitials(value);
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      totalRecords: "suggestionNewests/totalRecords",
    }),
    newestsData() {
      return this.$store.getters["suggestionNewests/newestsData"];
    },
    newestsIdData() {
      return this.$store.getters["suggestionNewests/newestsIdData"];
    },
  },
  watch: {
    pageIndex() {
      if (this.newestsData.length < this.totalRecords) {
        this.$store.dispatch("suggestionNewests/setPageIndex", this.pageIndex);
        this.$store.dispatch("suggestionNewests/setData");
      }
    },
    newestsIdData: {
      async handler(val) {
        if (val.length > 0) {
          this.routeFilterData();
        }
      },
      immediate: true,
      deep: true,
    },
    newestsData() {
      this.$nextTick(() => {
        if (this.observer && this.$refs.scrollSentinel) {
          this.observer.observe(this.$refs.scrollSentinel);
        }
      });
    },
  },
  methods: {
    getCurrentDateTime() {
      return currentDateTime();
    },    
    async routeFilterData() {
      const filteredData = await this.newestsIdData[0];
      const routeSuggestionId = lowerCaseKeys(this.$route.query);
      filteredData && routeSuggestionId.suggestionid
        ? this.cardDetail(filteredData)
        : "";
    },
    refreshData() {
      this.$store.dispatch("suggestionNewests/deleteNewestsData");
      this.$store.dispatch("suggestionNewests/setData");

      this.$store.dispatch("mostLiked/deleteMostLikedData");
      this.$store.dispatch("mostLiked/setData");
    },
    async liked(item) {
      this.tmpLikeId = item.Id;

      if (item.IsLiked) {
        //Delete Liked
        let id = null;
        item.Likes.forEach((element) => {
          if (element.UserId == this.user.Data.UserId) {
            id = element.Id;
          }
        });
        const body = {
          Id: id,
          SuggestionId: item.Id,
          UserId: this.user.Data.UserId,
        };
        const res = await suggestionService.fetchDeleteLike(body);
        if (res.Message == "like is deleted") {
          this.refreshData();
        }
      } else {
        //Create Liked
        const body = {
          UserId: this.user.Data.UserId,
          SuggestionId: item.Id,
        };
        const res = await suggestionService.fetchCreateLike(body);
        if (res.Data) {
          this.refreshData();
        }
      }
    },
    async createComment(item) {
      const body = {
        CommentText: this.commentText,
        SuggestionId: item.Id,
        UserId: this.user.Data.UserId,
      };
      try {
        const res = await suggestionService.fetchCreateComment(body);
        if (res.Data) {
          this.commentText = null;
          this.isCommentShowId = null;
          this.commentId = null;
          this.$toast.success("Yorumunuz başarıyla yapılmıştır.", {
            position: "top",
          });
          this.$store.dispatch("suggestionNewests/deleteNewestsData");
          this.$store.dispatch("suggestionNewests/setData");
        }
      } catch (error) {
        this.$toast.error("Yorumunuz gönderilirken bir hata oluştu.", {
          position: "top",
        });
      }
    },
    async editComment(event) {
      const body = {
        Id: this.commentEditData.Id,
        CommentText: event,
        SuggestionId: this.commentEditData.SuggestionId,
        UserId: this.commentEditData.UserId,
      };
      try {
        const res = await suggestionService.fetchUpdateComment(body);
        if (res.Data) {
          this.$toast.success("Yorumunuz başarıyla güncellendi.", {
            position: "top",
          });
          this.$store.dispatch("suggestionNewests/deleteNewestsData");
          this.$store.dispatch("suggestionNewests/setData");
          this.isCommentEdit = false;
        }
      } catch (error) {
        this.$toast.error("Yorumunuz güncellenirken bir hata oluştu.", {
          position: "top",
        });
      }
    },
    async deleteComment(item) {
      const body = {
        Id: item.Id,
        SuggestionId: item.SuggestionId,
        UserId: item.UserId,
      };
      try {
        const res = await suggestionService.fetchDeleteComment(body);
        if (res.Message == "comment is deleted") {
          this.$toast.success("Yorumunuz başarıyla silindi.", {
            position: "top",
          });
          this.$store.dispatch("suggestionNewests/deleteNewestsData");
          this.$store.dispatch("suggestionNewests/setData");
        }
      } catch (error) {
        this.$toast.error("Yorumunuz silinirken bir hata oluştu.", {
          position: "top",
        });
      }
    },
    async deleteCard() {
      try {
        const res = await suggestionService.fetchDeleteSuggestion(
          this.cardDeleteDataId
        );
        if (res.Message == "Suggestion is deleted") {
          this.$toast.success("İşleminiz başarıyla tamamlandı.", {
            position: "top",
          });
          this.$store.dispatch("suggestionNewests/deleteNewestsData");
          this.$store.dispatch("suggestionNewests/setData");
          await this.$store.dispatch(
              "mostSuggestionUsers/setMostSuggestionUsers"
            );
        } else {
          this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
            position: "top",
          });
        }
      } catch (error) {
        this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
          position: "top",
        });
      }
    },
    deleteCardShowModal(item) {
      this.isCardDelete = true;
      this.cardDeleteDataId = item;
      this.cardDropdownId = null;
    },
    commentEditShowModal(item) {
      this.commentEditData = item;
      this.isCommentEdit = true;
      this.commnetEditId = null;
    },
    async editSuggestion(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      const tmpData = item;
      if (item.FileId != null) {
        const res = await upload.fetchDownloadFile(item.FileId);
        tmpData.DownloadFile = {
          DownloadBinary: res.Data.DownloadBinary,
          Extension: res.Data.Extension,
          Filename: res.Data.Filename,
          Id: res.Data.Id,
          fileType: fileTypeCheck(res.Data.Extension),
        };
      }
      this.$emit("edit-suggestion", tmpData);
      this.cardDropdownId = null;
      this.$store.dispatch("loading/setIsLoading", false);
    },
    supportShowModal(item) {
      this.suggestionId = item;
      this.isSuggestionSupport = true;
    },
    whoLikedFn(item) {
      this.whoLikedId = this.whoLikedId === item ? null : item;
    },
    commentEditFn(item) {
      this.commnetEditId = this.commnetEditId === item ? null : item;
    },
    cardDropdownFn(item) {
      this.cardDropdownId = this.cardDropdownId === item ? null : item;
    },
    isCommentFn(item) {
      this.commentId = this.commentId === item ? null : item;
    },
    commentShowFn(item) {
      this.isCommentShowId = this.isCommentShowId === item ? null : item;
    },
    async cardDetail(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      this.detailData = item;
      this.detailData.ProjectPresentationDocumentFiles = [];
      this.detailData.DownloadFile = [];

      if (this.detailData.FileIds && this.detailData.FileIds.length > 0) {
        for await (let element of this.detailData.FileIds) {
          const res = await upload.fetchDownloadFile(element);
          this.detailData.DownloadFile.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      if (
        this.detailData.ProjectPresentationDocumentIds &&
        this.detailData.ProjectPresentationDocumentIds.length > 0
      ) {
        for await (let element of this.detailData
          .ProjectPresentationDocumentIds) {
          const res = await upload.fetchDownloadFile(element);
          this.detailData.ProjectPresentationDocumentFiles.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      this.$store.dispatch("loading/setIsLoading", false);
      this.isDetail = true;
    },
    clickOutSide(e) {
      let el = this.$refs.commentEditPoppup
        ? this.$refs.commentEditPoppup[0]
        : null;
      let whoLikedList = this.$refs.whoLikedList
        ? this.$refs.whoLikedList[0]
        : null;
      let carDropdown = this.$refs.carDropdown
        ? this.$refs.carDropdown[0]
        : null;
      let target = e.target;
      if (el && el !== target && !el.contains(target)) {
        this.commnetEditId = null;
      }
      if (
        whoLikedList &&
        whoLikedList !== target &&
        !whoLikedList.contains(target)
      ) {
        this.whoLikedId = null;
      }
      if (
        carDropdown &&
        carDropdown !== target &&
        !carDropdown.contains(target)
      ) {
        this.cardDropdownId = null;
      }
    },
    setupObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && this.newestsData.length < this.totalRecords) {
            this.pageIndex++;
          }
        },
        { rootMargin: '100px' }
      );
      this.$nextTick(() => {
        if (this.$refs.scrollSentinel) {
          this.observer.observe(this.$refs.scrollSentinel);
        }
      });
    },
    dateDiff(m1, m2 = this.getCurrentDateTime()) {
      const diff = this.$moment.preciseDiff(m1, m2, true);
      if (diff.years != 0) return diff.years + " yıl";
      else if (diff.months != 0) return diff.months + " ay";
      else if (diff.days != 0) return diff.days + " gün";
      else if (diff.hours != 0) return diff.hours + " saat";
      else if (diff.minutes != 0) return diff.minutes + " dk";
      else return diff.seconds + " sn";
    },
  },
  mounted() {
    this.setupObserver();
  },
  beforeMount() {
    document.addEventListener("click", this.clickOutSide);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickOutSide);
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  async created() {
    if (this.newestsData.length == 0) {
      this.$store.dispatch("suggestionNewests/setData");
    }
    const routeSuggestionId = lowerCaseKeys(this.$route.query);
    if (routeSuggestionId?.suggestionid) {
      await this.$store.dispatch(
        "suggestionNewests/setIdData",
        routeSuggestionId.suggestionid
      );
    }
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/scss/cards.scss";
</style>
